import { privateToPublic } from 'ethereumjs-util';
import { addTrailing0x } from './util';

/**
 * Generate publicKey from the privateKey.
 * This creates the uncompressed publicKey,
 * where 04 has stripped from left
 * @returns {string}
 */
export default function publicKeyOfPrivateKey(privateKey) {
    privateKey = addTrailing0x(privateKey);
    var publicKeyBuffer = privateToPublic(privateKey);
    return publicKeyBuffer.toString('hex');
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/eth-crypto/dist/es/public-key-by-private-key.js
// module id = 292
// module chunks = 0